export default {
    NODE_ENV: 'development',
    BASE_URL: 'http://135.181.29.143/',
    BASE_API_URL: 'http://zorion.alpha-innomed.com:4040/api/',
    STRIPE_TOKEN: 'YOUR_TOKEN',
}